import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE, CONTACT } from "@/data/pages";

export const Seo = ({ title, description, path = "/", image, jsonLd }) => {
  const url = `${SITE.domain}${path}`;
  const SERVICE_CITIES = ["Belfort", "Montbéliard", "Héricourt", "Grand-Charmont"];
  const cityNodes = SERVICE_CITIES.map((name) => ({ "@type": "City", name }));
  const localBusiness = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "AutoWash"],
    "@id": `${SITE.domain}/#business`,
    name: SITE.name,
    image: `${SITE.domain}/logo192.png`,
    logo: `${SITE.domain}/logo192.png`,
    url: SITE.domain,
    telephone: CONTACT.phone,
    email: CONTACT.email,
    slogan: SITE.slogan,
    priceRange: "€€",
    serviceType: "Auto Detailing & Upholstery Cleaning",
    description:
      "Detailing automobile & pressing auto, nettoyage de textiles (sièges, canapés, matelas) par injecteur-extracteur et nettoyage de surfaces extérieures d'habitat à Belfort, Montbéliard, Héricourt et Grand-Charmont.",
    address: {
      "@type": "PostalAddress",
      addressRegion: "Bourgogne-Franche-Comté",
      addressCountry: "FR",
    },
    areaServed: cityNodes,
    serviceArea: cityNodes,
  };
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <html lang="fr" />
      <script type="application/ld+json">{JSON.stringify(localBusiness)}</script>
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
